import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-theme-setting",
  "use": "oc-theme-setting-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-theme-setting\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 501.568v382.016H256V501.568l-153.6-160L243.2 147.2H320a203.52 203.52 0 0 0 192 131.968A213.952 213.952 0 0 0 704 147.2h76.8l140.8 194.496zM819.2 64h-172.8l-12.8 27.776a123.072 123.072 0 0 1-243.2 0L377.6 64H204.8L0 348.8l179.2 187.52V960h665.6V543.232L1024 348.8z\" p-id=\"6416\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol